<script>
/* global L : true*/

import { httpGET } from './../../js/utils'
import { app_state } from './../../js/app_state'

export default {
    name: "RainViewerMixin",

    props: {
        rainviewerLayerToDisplay: Number,
    },

    watch: {
        rainviewerLayerToDisplay: function (newVal, oldVal) {
          this.updateOverlay(oldVal, newVal);
        }
    },

    data() {
        return {
            rainviewer_overlay: null,
            rainviewer_layers: [],
            latest_timestamp: null,
        }
    },

    mounted() {
        this.rainviewer_overlay = L.tileLayer('', {
                                            tileSize: 256,
                                            opacity: 0.5,
                                            });
        this.overlay_maps["Rainviewer"] = this.rainviewer_overlay;
        this.rainviewer_layers = L.layerGroup();

    },

    methods: {
        updateTimestampsFromServer() {          
            httpGET("https://api.rainviewer.com/public/weather-maps.json")
            .then((response) => {
                let remoteData = JSON.parse(response);
                let as = app_state;
                // parse remote data
                as.rainviewerTimestamps = [];
                var fusedData = [];
                for (let i = 0; i < remoteData["radar"]["past"].length; i++) {
                    as.rainviewerTimestamps.push(remoteData["radar"]["past"][i].time);
                    fusedData.push(remoteData["radar"]["past"][i]);
                }
                for (let i = 0; i < remoteData["radar"]["nowcast"].length; i++) {
                    as.rainviewerTimestamps.push(remoteData["radar"]["nowcast"][i].time);
                    fusedData.push(remoteData["radar"]["nowcast"][i]);
                }
                
                if (this.latest_timestamp != as.rainviewerTimestamps[as.rainviewerTimestamps.length - 1]) {
                    // update readable timestamps only if new ones
                    as.readableRainviewerTimestamps = [];
                    for (const ts of as.rainviewerTimestamps) {
                        const tsstr = (new Date(ts * 1000)).toString();
                        const tstd = tsstr.substring(16, 24);
                        as.readableRainviewerTimestamps.push(tstd);
                    }
                    // update rainviewer layers only if new ones
                    this.populaterainviewer_layers(remoteData.host, fusedData);
                    // update latest timestamp
                    this.latest_timestamp = app_state.rainviewerTimestamps[app_state.rainviewerTimestamps.length - 1];
                }
                // display latest rainviewer layer available
                this.mymap.addLayer(as.rainviewer_layers[app_state.current_rainviewer_timestamp]);
            })
            .catch(() => {});
        },

        updateOverlay(previousLayer, currentLayer) {
            // take care of overlay update
            this.mymap.addLayer(app_state.rainviewer_layers[currentLayer]);
            this.mymap.removeLayer(app_state.rainviewer_layers[previousLayer]);
        },

        populaterainviewer_layers(host, data) {
            app_state.rainviewer_layers = [];
            for (const ts of data) {
                const rainviewerLayer = L.tileLayer(host + data.find(d => d.time === ts.time).path + '/256/{z}/{x}/{y}/2/1_1.png', {
                    tileSize: 256,
                    opacity: 0.5,
                    time: ts * 1000,
                });
                app_state.rainviewer_layers.push(rainviewerLayer);
            }
            this.$emit('newRainviewerOverlays', app_state.rainviewer_layers.length, app_state.readableRainviewerTimestamps);
            this.$emit('rainviewerOverlayAdded');
        }

    },
}
</script>